import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

const SeasonButton = (props) => {
  return (
    <Chip
      label={props.season.name}
      component={Link}
      to={"/season/" + props.season.id}
      clickable
      variant="outlined"
      sx={{ m: 0.5 }}
    />
  );
};

export default SeasonButton;
